@import "../../shared.scss";

.error-message {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0 $spacing-gutter;
    padding-top: 6rem;
  }

  &__heading {
    color: $red-onboarding;
    font-family: $font-stack;
    font-weight: $font-weight-bolder;
    letter-spacing: $letter-spacing-medium;
    text-align: center;
    font-size: $font-size-h1;
    line-height: 3.6rem;

   @media screen and (min-width: $breakpoint-md) {
      font-size: $font-size-h1-large;
      line-height: 6rem;
    }
  }
}
